import { landingApiRequest } from '@/lib/landing-api'
import { ApiClientError } from '@/lib/api/client'
import { parseAvatarConfig, type AvatarConfig } from './avatar-catalog'
import type { AvatarPiece } from './avatar-custom'

export function fetchDonorCampaignAvatar(campaignId: number, signal?: AbortSignal) {
  return landingApiRequest<{
    avatar: unknown
    items: AvatarPiece[]
    institution_name?: string
    sales_open?: boolean
  }>(`/api/donor/campaigns/${campaignId}/avatar`, { signal, cache: 'no-store' })
}

export async function saveDonorAvatar(
  avatar: AvatarConfig,
  campaignId?: number
): Promise<AvatarConfig> {
  const { custom, ...base } = avatar
  const response = await landingApiRequest<{ avatar: unknown }>('/api/donor/avatar', {
    method: 'PUT',
    body: JSON.stringify({
      avatar: base,
      ...(campaignId ? { campaign_id: campaignId } : {}),
      ...(custom ? { custom_item_ids: custom.map((piece) => piece.id) } : {}),
    }),
  })
  const saved = parseAvatarConfig(response.avatar)
  if (!saved)
    throw new ApiClientError('Não foi possível confirmar seu avatar. Tente novamente.', 0)
  return saved
}
